import React from 'react';

import { useSelector } from 'react-redux';
import 'src/components/RedirectionToAddingJobAlert.scss';

import Plus from '@mdi/svg/svg/plus.svg';


const RedirectionToAddingJobAlert = () => {
  const newJobAlertText = 'Nowy JobAlert';
  const addJobAlertURL = useSelector(state => state.configReducer.addJobAlertURL);

  return (
    <a
      data-test="anchor-addJobAlert"
      href={ addJobAlertURL }
      styleName="add-job-alert"
      title="Dodaj nowe powiadomienie"
    >
      <Plus styleName="add-job-alert__icon" viewBox="0 0 24 24" />
      <span>{newJobAlertText}</span>
    </a>
  );
};

export default RedirectionToAddingJobAlert;
